export const preloadImages = pictures => {
  pictures.forEach(picture => {
    const img = new Image();
    img.src = picture.imagePath;
  });
};